export const ActivityFeedGroupItem = ({ leftSlot, rightSlot }) => {
  return (
    <div className="activity-feed-group-item">
      <div className="activity-feed-group-item__left-slot">{leftSlot}</div>
      <div className="activity-feed-group-item__right-slot">{rightSlot}</div>
    </div>
  );
};
